import React from 'react'

interface ScheduleNavigationProps {
  onNavigate: (sectionId: string) => void
}

export const ScheduleNavigation: React.FC<ScheduleNavigationProps> = ({
  onNavigate
}) => {
  return (
    <nav className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8 text-sm md:text-base">
      <button
        onClick={() => onNavigate('shuttle-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Shuttle Schedule
      </button>
      <button
        onClick={() => onNavigate('sunday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Sunday, July 20
      </button>
      <button
        onClick={() => onNavigate('monday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Monday, July 21
      </button>
      <button
        onClick={() => onNavigate('tuesday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Tuesday, July 22
      </button>
      <button
        onClick={() => onNavigate('wednesday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Wednesday, July 23
      </button>
      <button
        onClick={() => onNavigate('thursday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Thursday, July 24
      </button>
      <button
        onClick={() => onNavigate('friday-schedule')}
        className="text-[#142841] underline hover:no-underline px-2 py-1 bg-transparent border-none cursor-pointer"
      >
        Friday, July 25
      </button>
    </nav>
  )
}
